import { useMutation, useQuery } from '@tanstack/react-query';

import {
  deleteMsgChatRoom,
  deleteMsgNpoDonationChatRoom,
  deleteMsgNpoUserChatRoom,
  editMsgChatRoom,
  editMsgNpoDonationChatRoom,
  editMsgNpoUserChatRoom,
  getNpoDonationsChatRooms,
  getUserNpoChatRooms,
  getVolunteerEventsChatRooms,
  publishMsgChatRoom,
  publishMsgNpoDonationChatRoom,
  publishMsgUserNpoChatRoom,
  publishResponseUserNpoChatRoom
} from '../functions/chatRooms';

// Volunteer Events
export const useGetVolunteerEventChatRooms = () =>
  useQuery({
    queryKey: ['get-volunteer-chat-rooms'],
    queryFn: () => getVolunteerEventsChatRooms()
  });

export const usePublishMsgVolunteerEvent = () =>
  useMutation({
    mutationKey: ['publish-msg-volunteer-event'],
    mutationFn: publishMsgChatRoom
  });

export const useEditMsgVolunteerEvent = () =>
  useMutation({
    mutationKey: ['edit-msg-volunteer-event'],
    mutationFn: editMsgChatRoom
  });

export const useDeleteMsgVolunteerEvent = () =>
  useMutation({
    mutationKey: ['delete-msg-volunteer-event'],
    mutationFn: deleteMsgChatRoom
  });

// Individual to NPO
export const useGetIndividualNpoChatRooms = () =>
  useQuery({
    queryKey: ['get-individual-npo-chat-rooms'],
    queryFn: () => getUserNpoChatRooms()
  });

export const usePublishResponseIndividualNpo = () =>
  useMutation({
    mutationKey: ['publish-response-individual-npo'],
    mutationFn: publishResponseUserNpoChatRoom
  });

export const usePublishMsgIndividualNpo = () =>
  useMutation({
    mutationKey: ['publish-msg-individual-npo'],
    mutationFn: publishMsgUserNpoChatRoom
  });

export const useEditMsgIndividualNpo = () =>
  useMutation({
    mutationKey: ['edit-msg-individual-npo'],
    mutationFn: editMsgNpoUserChatRoom
  });

export const useDeleteMsgIndividualNpo = () =>
  useMutation({
    mutationKey: ['delete-msg-individual-npo'],
    mutationFn: deleteMsgNpoUserChatRoom
  });

//NPO Donations
export const useGetNpoDonationsChatRooms = () =>
  useQuery({
    queryKey: ['get-npo-donations-chat-rooms'],
    queryFn: () => getNpoDonationsChatRooms()
  });

export const usePublishMsgNpoDonation = () =>
  useMutation({
    mutationKey: ['publish-msg-npo-donation'],
    mutationFn: publishMsgNpoDonationChatRoom
  });

export const useEditMsgNpoDonation = () =>
  useMutation({
    mutationKey: ['edit-msg-npo-donation'],
    mutationFn: editMsgNpoDonationChatRoom
  });

export const useDeleteMsgNpoDonation = () =>
  useMutation({
    mutationKey: ['delete-msg-npo-donation'],
    mutationFn: deleteMsgNpoDonationChatRoom
  });
